import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Master";
import getToken from "app/api/getToken";

import { IMaster } from "app/api/types/Masters";

export const EDIT_MASTER_REQUEST = "EDIT_MASTER_REQUEST";
export const EDIT_MASTER_SUCCESS = "EDIT_MASTER_SUCCESS";
export const EDIT_MASTER_FAIL = "EDIT_MASTER_FAIL";

export const editMaster = (data: IMaster) => (dispatch: any): any => {
  dispatch({ type: EDIT_MASTER_REQUEST });

  const token = getToken();

  return api
    .editMaster(token, data)
    .then((response: AxiosResponse) => {
      const master: IMaster = get(response, "data", {});
      dispatch({ type: EDIT_MASTER_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: EDIT_MASTER_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
